import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

// Minimal single-date flatpickr binding, e.g. the report note date field.
export default class extends Controller {
  connect() {
    // altInput shows the date as m/d/Y while the real (submitted) field
    // keeps the ISO Y-m-d value the server expects.
    this.picker = flatpickr(this.element, {
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'm/d/Y',
      maxDate: 'today',
      allowInput: true,
    })
  }

  disconnect() {
    if (this.picker) this.picker.destroy()
    this.picker = null
  }
}
